export default "__VITE_ASSET__OsXe9euF__"